module.exports = __webpack_public_path__ + "static/media/logotipo.7ea4971c.png";